"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.player_video = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const player_video = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'player-video-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M14.375 10.6495C14.6071 10.5155 14.75 10.2679 14.75 10C14.75 9.73205 14.6071 9.48446 14.375 9.35048L8.375 5.88638C8.14295 5.7524 7.85705 5.7524 7.625 5.88638C7.39295 6.02035 7.25 6.26795 7.25 6.5359V13.4641C7.25 13.7321 7.39295 13.9796 7.625 14.1136C7.85705 14.2476 8.14295 14.2476 8.375 14.1136L14.375 10.6495ZM8.75 12.1651V7.83494L12.5 10L8.75 12.1651Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3 3.25C2.0335 3.25 1.25 4.0335 1.25 5V15C1.25 15.9665 2.0335 16.75 3 16.75H17C17.9665 16.75 18.75 15.9665 18.75 15V5C18.75 4.0335 17.9665 3.25 17 3.25H3ZM2.75 5C2.75 4.86193 2.86193 4.75 3 4.75H17C17.1381 4.75 17.25 4.86193 17.25 5V15C17.25 15.1381 17.1381 15.25 17 15.25H3C2.86193 15.25 2.75 15.1381 2.75 15V5Z', fill: '#4B5563' })));
};
exports.player_video = player_video;
